import React, { Fragment } from "react";
import { Animated } from "react-animated-css";
import { Container, Grid, Icon, Segment } from "semantic-ui-react";

/**
 * @author
 * @function AboutGrid
 **/

const AboutGrid = ({ getClickedValue }) => {
  let arrayOfNames = [
    { name: "School", color: "#C7C11A", range: "2002 - 2015" },
    { name: "12th", color: "#D9D55B", range: "2015 - 2017" },
    { name: "College", color: "#E5D68A", range: "2017 - 2021 (expexted)" },
    { name: "Work", color: "#DDD101", range: "2020 - current" }
  ];
  const SegmentDuplicate = name => {
    return (
      <>
        <Grid.Column style={{ margin: "0px", padding: "0px" }}>
          <Animated animationIn="pulse">
            <Segment
              onClick={() => getClickedValue(name.name)}
              textAlign="center"
              attached="bottom"
              style={{
                height: "100px",
                margin: "auto",
                padding: "25px",
                cursor : "pointer",
                background: name.color
              }}
            >
              {name.name}
              <Icon name="book"></Icon>
              <p
                style={{
                  margin: "0px",
                  color: "#FFFFFF",
                  fontSize: "8px",
                  fontWeight: "lighter"
                }}
              >
                (2002-2015)
              </p>
            </Segment>
          </Animated>
        </Grid.Column>
      </>
    );
  };
  return (
    <Fragment>
      <Container>
        <Grid columns={4} style={{ bottom: 0 }}>
          {arrayOfNames.map(name => SegmentDuplicate(name))}
        </Grid>
      </Container>
    </Fragment>
  );
};

export default AboutGrid;
